import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
import {
  finalSignForm,
  lockForm,
  shareLockedForm,
  signForm,
} from "./supervisionScripts";

function Signatures({
  data,
  isSupervisee,
  isSupervisor,
  lockedOn,
  handleSave,
  callback,
}) {
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  const isSigned = (role) => {
    return (
      data?.Related?.filter(
        (s) => s.ObjectType === "Signature" && s.ObjectJSON.role === role
      ).length > 0
    );
  };

  const filteredSignature = (role) => {
    return (
      data?.Related?.filter(
        (s) => s.ObjectType === "Signature" && s.ObjectJSON.role === role
      ) || []
    );
  };

  const SharedWithYou = () => {
    return (
      data?.Related?.filter(
        (s) =>
          s.ObjectType === "Shared" &&
          s.Active === true &&
          s.ObjectJSON.azureId.toUpperCase() ===
            safyInfo.user.azureId.toUpperCase()
      ) || []
    );
  };

  const handleSign = async (type) => {
    handleSave();
    const obj = {
      Action: "Insert",
      ObjectType: "Signature",
      ObjectJSON: {
        azureId: safyInfo.user.azureId.toUpperCase(),
        name: safyInfo.user.displayName,
        date: new Date().toLocaleDateString(),
        role: type,
      },
    };
    const form = await signForm(data.SubmissionId, obj);
    if (form.data[0].code === "success") {
      const related = data.Related ? [...data.Related, obj] : [obj];
      if (
        type === lockedOn &&
        related.filter(
          (s) => s.ObjectType === "Signature" && s.ObjectJSON.role === lockedOn
        ).length === 1
      ) {
        //FinalSigned
        await finalSignForm(data.SubmissionId);
        //Eureka Lock Form
        await lockForm(data.SubmissionId);
        //Send Share emails
        await shareLockedForm(data, type);
      }
      if (callback) {
        callback();
        handleSave();
      }
    } else {
      toast.error(`Error signing form: ${form.data[0].message.toString()}`);
    }
  };

  return (
    <div>
      <div className="h4 mt-4">Signatures</div>
      <div>
        {isSupervisee && !isSigned("Supervisee") && (
          <>
            <button
              className="btn btn-primary m-2"
              onClick={() => handleSign("Supervisee")}
              disabled={
                data?.Results?.DateSupervision === undefined ||
                data?.Results?.DateSupervision === "" ||
                !data?.Results?.LengthOfSupervision ||
                data?.Results?.LengthOfSupervision === "0" ||
                moment(data?.Results?.DateSupervision).isAfter(moment())
              }
            >
              Sign as Supervisee
            </button>
            {data?.Results?.DateSupervision === undefined ||
            data?.Results?.DateSupervision === "" ||
            data?.Results?.LengthOfSupervision === undefined ||
            data?.Results?.LengthOfSupervision === "0"
              ? "* Date of Supervision & Length of Supervision Session is required before signing"
              : moment(data?.Results?.DateSupervision).isAfter(moment())
              ? "* Date of Supervision cannot be a future date"
              : "By signing this supervision log, I agree with content and next steps outlined."}
          </>
        )}
        {isSigned("Supervisee") && (
          <div className="border rounded p-2 m-2 bg-success text-white">
            <div>{`Supervisee: ${
              filteredSignature("Supervisee")[0].ObjectJSON.name
            }`}</div>
            <div>
              {`Date: ${
                filteredSignature("Supervisee")[0].ObjectJSON.date &&
                new Date(
                  filteredSignature("Supervisee")[0].ObjectJSON.date
                ).toDateString()
              }
                `}
            </div>
          </div>
        )}
      </div>
      <div>
        {isSupervisor && !isSigned("Supervisor") && (
          <>
            <button
              className="btn btn-primary m-2"
              onClick={() => handleSign("Supervisor")}
              disabled={
                data?.Results?.DateSupervision === undefined ||
                data?.Results?.DateSupervision === "" ||
                !data?.Results?.LengthOfSupervision ||
                data?.Results?.LengthOfSupervision === "0" ||
                moment(data?.Results?.DateSupervision).isAfter(moment())
              }
            >
              Sign as Supervisor
            </button>
            {data?.Results?.DateSupervision === undefined ||
            data?.Results?.DateSupervision === "" ||
            !data?.Results?.LengthOfSupervision ||
            data?.Results?.LengthOfSupervision === "0"
              ? "* Date of Supervision & Length of Supervision Session is required before signing"
              : moment(data?.Results?.DateSupervision).isAfter(moment())
              ? "* Date of Supervision cannot be a future date"
              : null}
          </>
        )}
        {isSigned("Supervisor") && (
          <div className="border rounded p-2 m-2 bg-success text-white">
            <div>{`Supervisor: ${
              filteredSignature("Supervisor")[0].ObjectJSON.name
            }`}</div>
            <div>
              {`Date: ${
                filteredSignature("Supervisor")[0].ObjectJSON.date &&
                new Date(
                  filteredSignature("Supervisor")[0].ObjectJSON.date
                ).toDateString()
              }
                `}
            </div>
          </div>
        )}
      </div>
      <div>
        {filteredSignature("SharedSignature").map(
          (s) =>
            s.ObjectJSON.azureId.toUpperCase() ===
              safyInfo.user.azureId.toUpperCase() && (
              <div
                key={`shared${s.RelatedId}`}
                className="border rounded p-2 m-2 bg-info text-white"
              >
                <div>{`Shared With Signature: ${s.ObjectJSON.name}`}</div>
                <div>{`Date: ${new Date(
                  s.ObjectJSON.date
                ).toDateString()}`}</div>
              </div>
            )
        )}
        {SharedWithYou().length > 0 && (
          <button
            className="btn btn-primary m-2"
            onClick={() => {
              handleSign("SharedSignature");
            }}
            disabled={
              data?.Results?.DateSupervision === undefined ||
              data?.Results?.DateSupervision === "" ||
              !data?.Results?.LengthOfSupervision ||
              data?.Results?.LengthOfSupervision === "0" ||
              moment(data?.Results?.DateSupervision).isAfter(moment())
            }
          >
            Sign as Shared With
          </button>
        )}
      </div>
    </div>
  );
}

export default Signatures;
